
import Vue from "vue";
import store from "@/store";
import { TASK } from "@/store/task";
import { mapState } from "vuex";
import { IRootState } from "@/store/types";
import { ITimelineItem } from "@/store/task/types";
import { APPLICATION } from "@/store/applications";
import { APPLICATION_ACTIONS } from "@/store/applications/actions";

const TASK_ACTIONS_MAPPINGS = {
  FollowUpPersonalGuarantee: APPLICATION.NS(
    APPLICATION.ACTIONS.SHOW_FOLLOW_UP_PERSONAL_GUARANTEE
  ),
  ReferredToCreditTeam: APPLICATION.NS(APPLICATION.ACTIONS.SHOW_CREDIT_OUTCOME),
  CardAccountSetup: APPLICATION.NS(APPLICATION.ACTIONS.SHOW_CARD_ACCOUNT_SETUP),
  ModifyAccountNumber : APPLICATION.NS(APPLICATION.ACTIONS.SHOW_MODIFY_ACCOUNT_NUMBER),
  JdeAccountSetup: APPLICATION.NS(APPLICATION.ACTIONS.SHOW_JDE_ACCOUNT_SETUP),
  CallbackRequested: APPLICATION.NS(
    APPLICATION.ACTIONS.SHOW_REQUEST_FOR_CALLBACK
  )
} as any;

export default Vue.extend({
  props: {
    id: {
      type: [Number, String],
      required: true
    }
  },
  watch: {
    id: {
      immediate: true,
      handler(val: any) {
        // Clear out the existing array
        this.items = [];

        if (val) {
          this.$store.dispatch(
            TASK.NS(TASK.ACTIONS.LOAD_APPLICATION_TIMELINE),
            val
          );
        }
      }
    }
  },
  computed: {
    userName() {
      return store.state.auth.user.userName;
    },
    items: {
      get(): any {
        return this.$store.state.tasks.applicationTimeline;
      },
      set(items: any) {
        this.$store.commit(
          TASK.NS(TASK.MUTATIONS.SET_APPLICATION_TIMELINE),
          items
        );
      }
    }
  },
  methods: {
    onTaskActionClick(task: ITimelineItem) {
      // Check if there is an action for the task type
      if (TASK_ACTIONS_MAPPINGS.hasOwnProperty(task.taskType)) {
        const action = TASK_ACTIONS_MAPPINGS[task.taskType];
        if (action && action !== "") {
          this.$store.dispatch(TASK_ACTIONS_MAPPINGS[task.taskType], task);
          return;
        }
      }
      alert(`Sorry, no handler has been implement for ${task.taskType} yet`);
    },
    onAssignToMeClick(task: ITimelineItem) {
      if (task.assignedTo && task.assignedTo !== this.userName) {
        this.$store.dispatch(
          APPLICATION.NS(APPLICATION_ACTIONS.OPEN_ASSIGN_TO_ME_CONFIRMATION)
        );
      } else {
        this.$store.dispatch(TASK.NS(TASK.ACTIONS.ASSIGN_TASK), task);
      }
    },
    async onUnassignClick(task: ITimelineItem) {
      this.$store.dispatch(TASK.NS(TASK.ACTIONS.UNASSIGN_TASK), task);
    },
    isAssignedToUser(item: ITimelineItem): boolean {
      return item.assignedTo === this.userName;
    }
  }
});
